import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-metric-categories',
  templateUrl: './help-metric-categories.component.html',
  styleUrls: ['./help-metric-categories.component.scss']
})
export class HelpMetricCategoriesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
